import { LocalStorageKeys } from '../app/constants'
import { globalState } from '@codeleap/store'

export const impersonating = globalState(
  {
    isImpersonating: false,
  },
  {
    persistKey: LocalStorageKeys.IMPERSONATING,
  },
)

export function stopImpersonating() {
  impersonating.set({
    isImpersonating: false,
  })
}

export function isImpersonating() {
  return impersonating.get()?.isImpersonating ?? false
}

export const useIsImpersonating = () => {
  const isImpersonating = impersonating.use(s => s?.isImpersonating ?? false)

  return isImpersonating
}
